import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
import axios from "../../../services/interceptor/Interceptor";
import Config from "services/config/config";
import { handleValidateObj } from 'constants/objValues/objvalues';
import DivLayout from 'components/sales/divLayout/divLayout';
import "./pos.css";
import { is } from 'date-fns/locale';
import Images from 'assets/images/imageData';

const EmployeePosMapping = ({
  match,
  getSiteData,
  siteDetails,
  fetchEmployeePosDevices,
  posEmployeeDetails
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [modal, setModal] = useState(false);
  const emailModalHide = () => setModal(false);
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState('');
  const [otpVal,setOTP] = useState('');
  const [data, setData] = useState([]);
  
  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])
    

  useEffect(() => {
    if (fetchEmployeePosDevices !== null);
    (async () => {
      setIsLoading(true);
      await fetchEmployeePosDevices();
      setIsLoading(false);
    })();
  },[fetchEmployeePosDevices]);

  useEffect(() => {
      if(posEmployeeDetails !== undefined && posEmployeeDetails !== null) {
        setData(posEmployeeDetails?.materials); 
      }
  },[posEmployeeDetails]);

  // console.log('koko - ' + JSON.stringify(data));

  return (
    <Layout
      title={localization.posStockMapping}
      isLoading={isLoading}
    >
      <>
      <div className="container-fluid">
         {data?.length > 0 ?
          <table className="panel-table table table-bordered">
            <thead>
                <tr>
                   <th style={{'text-align':'center','width':'10%'}}>S.No</th> 
                   {/* <th>Item No.</th>  */}
                   <th style={{'text-align':'center','width':'45%'}}>Serial Number</th> 
                   {/* <th>Location Code</th>  */}
                   <th style={{'text-align':'center','width':'45%'}}>Employee Code</th>
                </tr>
            </thead>
            <tbody>
            {data.map((item, x) => 
              <tr key={x}>
                  <td style={{'text-align':'center'}}>{x+1}</td> 
                  {/* <td>{item.itemNo}</td>  */}
                  <td style={{'text-align':'center'}}>{item?.serialNo}</td> 
                  {/* <td>{item.locationCode}</td>  */}
                  <td style={{'text-align':'center'}}>{item?.employeeCode}</td>
              </tr> 
            )}

            </tbody>
          </table>
         : <div>
               <img src={Images?.NoData} alt="" width="100%" />
            </div>
          }
        </div>
      </> 
    </Layout>
  );
};
export default EmployeePosMapping;
